import RelatedTopicModal from "./RelatedTopicModal.data"

export default RelatedTopicModal
